import { TextField, styled } from "@mui/material";

const CustomTextField = styled((props: TextFieldProps) => (
    <TextField InputProps={{ disableUnderline: true }} {...props} />
))(() => ({
    "& .MuiFilledInput-root": {
        overflow: "hidden",
        borderRadius: 6,
        backgroundColor: "#FFFFFF",
        border: "0px solid",
        boxShadow: `0 2px 6px 0 rgba(0,0,0,0.08)`,
        borderColor: "transparent",
        paddingRight: "50px",
        "&:hover": {
            backgroundColor: "#FFFFFF",
            borderColor: "transparent",
        },
        "&.Mui-focused": {
            backgroundColor: "#FFFFFF",
            boxShadow: `0 2px 6px 0 rgba(0,0,0,0.08)`,
            borderColor: "transparent",
        },
    },
    "& .MuiFilledInput-root:before": {
        borderBottom: "none !important",
    },
    "& .MuiChip-root": {
        borderRadius: "6px",
    },
}));

export default CustomTextField;